// Language translations for ZentraQR
export const translations = {
  pt: {
    // Navbar
    nav: {
      features: 'Funcionalidades',
      pricing: 'Preços',
      faq: 'FAQ',
      contact: 'Contacto',
      demo: 'Demo',
      login: 'Entrar',
    },
    // Hero Section
    hero: {
      badge: 'Novo: Pagamentos automáticos',
      title1: 'Pedidos. Gestão. Pagamentos.',
      title2: 'Tudo num só lugar.',
      description: 'Transforme o seu restaurante com menus digitais via QR Code. Clientes fazem pedidos pelo telemóvel, você gere tudo em tempo real.',
      cta: 'Começar Agora',
      demo: 'Ver Demo',
      socialProof: '500+ restaurantes',
      socialProofSub: 'já usam ZentraQR',
    },
    // Problem Section
    problem: {
      title1: 'Porque a gestão de restaurantes',
      title2: 'não deve ser complicada',
      description: 'Vivemos o caos dos restaurantes — por isso criamos uma forma mais simples de gerir pedidos e conectar com os clientes.',
      card1Title: 'Tudo num Só Lugar',
      card1Desc: 'Chega de apps dispersas. Chat, pedidos e pagamentos num único sistema organizado.',
      card2Title: 'Pagamentos Sem Fricção',
      card2Desc: 'Preços claros e pagamento instantâneo — porque receber não deveria ser um jogo de adivinhação.',
      card3Title: 'Sistema de Confiança',
      card3Desc: 'Cada pedido é registado e rastreável. Foque-se no serviço, não nas preocupações.',
    },
    // Marquee
    marquee: {
      title: 'Para todos os tipos de estabelecimentos',
      restaurants: 'Restaurantes',
      cafes: 'Cafés',
      bars: 'Bares',
      bistros: 'Bistrôs',
      foodCourts: 'Food Courts',
      pizzerias: 'Pizzarias',
      bakeries: 'Padarias',
      rooftops: 'Rooftops',
      gastrobars: 'Gastrobares',
      canteens: 'Cantinas',
    },
    // Features Section
    features: {
      title1: 'Fizemos a parte difícil,',
      title2: 'agora é a sua vez de servir',
      description: 'Quer seja para gerir o restaurante ou para o cliente fazer pedidos, tudo foi desenhado para fluir naturalmente.',
      tabRestaurant: 'Para o Restaurante',
      tabClient: 'Para o Cliente',
      // Restaurant features
      dashboard: 'Dashboard em Tempo Real',
      dashboardDesc: 'Acompanhe pedidos, receitas e estatísticas ao vivo. Visualize tudo num único painel.',
      orders: 'Gestão de Pedidos',
      ordersDesc: 'Receba e gira pedidos automaticamente. Notificações instantâneas para a cozinha.',
      payments: 'Pagamento Automático',
      paymentsDesc: 'Integração com Stripe para pagamentos online. Clientes pagam direto pelo telemóvel.',
      menu: 'Gestão de Menu',
      menuDesc: 'Adicione, edite e organize categorias e produtos facilmente. Fotos e extras incluídos.',
      // Client features
      scan: 'Scan & Order',
      scanDesc: 'Basta escanear o QR code na mesa para aceder ao menu completo instantaneamente.',
      interface: 'Interface Intuitiva',
      interfaceDesc: 'Menu visual com fotos, descrições e preços. Navegação simples e rápida.',
      callWaiter: 'Chamar Empregado',
      callWaiterDesc: 'Um clique para chamar o empregado à mesa. Sem esperas desnecessárias.',
      trackOrder: 'Acompanhar Pedido',
      trackOrderDesc: 'Veja o estado do seu pedido em tempo real. Saiba quando está pronto.',
    },
    // How it works
    howItWorks: {
      title: 'Comece em',
      titleHighlight: '3 passos simples',
      step1: 'Configure o Menu',
      step1Desc: 'Adicione categorias, produtos com fotos e preços. Personalize com as cores da sua marca.',
      step2: 'Imprima os QR Codes',
      step2Desc: 'Gere QR codes únicos para cada mesa. Imprima e coloque nas mesas do seu estabelecimento.',
      step3: 'Receba Pedidos',
      step3Desc: 'Clientes escaneiam, fazem pedidos e você gere tudo no dashboard em tempo real.',
    },
    // Pricing
    pricing: {
      title: 'Planos Simples e',
      titleHighlight: 'Transparentes',
      description: 'Escolha o plano ideal para o tamanho do seu negócio',
      monthly: 'Mensal',
      annual: 'Anual',
      discount: '-20%',
      mostPopular: 'MAIS POPULAR',
      starter: 'Starter',
      starterDesc: 'Para pequenos restaurantes',
      pro: 'Pro',
      proDesc: 'Para restaurantes em crescimento',
      enterprise: 'Enterprise',
      enterpriseDesc: 'Para redes e franquias',
      month: '/mês',
      custom: 'Custom',
      cta: 'Começar Grátis',
      ctaEnterprise: 'Falar com Vendas',
      // Features
      tables10: 'Até 10 mesas',
      tables30: 'Até 30 mesas',
      tablesUnlimited: 'Mesas ilimitadas',
      menuUnlimited: 'Menu ilimitado',
      dashboardBasic: 'Dashboard básico',
      dashboardAdvanced: 'Dashboard avançado',
      emailSupport: 'Suporte por email',
      prioritySupport: 'Suporte prioritário',
      onlinePayments: 'Pagamentos online',
      realTimeNotifications: 'Notificações em tempo real',
      multiRestaurants: 'Multi-restaurantes',
      customAPI: 'API personalizada',
      integrations: 'Integrações',
      dedicatedManager: 'Gerente dedicado',
      slaGuaranteed: 'SLA garantido',
    },
    // FAQ
    faq: {
      title: 'Perguntas Frequentes',
      description: 'Tudo o que precisa saber sobre o ZentraQR',
      q1: 'Quanto tempo demora a configurar?',
      a1: 'Menos de 30 minutos. Basta criar uma conta, adicionar o seu menu e imprimir os QR codes. O nosso sistema é intuitivo e não requer conhecimentos técnicos.',
      q2: 'Preciso de hardware especial?',
      a2: 'Não! O ZentraQR funciona com qualquer dispositivo com acesso à internet. Os seus clientes usam os próprios telemóveis e você gere tudo pelo browser.',
      q3: 'Como funcionam os pagamentos?',
      a3: 'Integramos com Stripe para pagamentos seguros. Os clientes podem pagar online pelo telemóvel ou optar por pagar no balcão. Você escolhe quais opções oferecer.',
      q4: 'Posso personalizar o menu?',
      a4: 'Absolutamente! Adicione categorias, produtos com fotos, descrições, extras e defina preços. Pode ainda personalizar as cores para combinar com a sua marca.',
      q5: 'Existe período de teste?',
      a5: 'Sim! Oferecemos 14 dias grátis sem compromisso e sem necessidade de cartão de crédito. Experimente todas as funcionalidades antes de decidir.',
    },
    // CTA Section
    cta: {
      title1: 'Pronto para transformar',
      title2: 'o seu restaurante?',
      description: 'Junte-se aos 500+ restaurantes que já simplificaram a gestão de pedidos. Comece gratuitamente hoje.',
      button: 'Começar Grátis por 14 Dias',
      noCard: 'Sem cartão de crédito',
      quickSetup: 'Configuração em 5 min',
      cancelAnytime: 'Cancele quando quiser',
    },
    // Footer
    footer: {
      description: 'Sistema completo de menu digital via QR Code. Pedidos, gestão e pagamentos — tudo num só lugar.',
      product: 'Produto',
      contact: 'Contacto',
      sendMessage: 'Enviar mensagem →',
      rights: '© 2026 ZentraQR. Todos os direitos reservados.',
      terms: 'Termos',
      privacy: 'Privacidade',
      admin: 'Admin',
    },
    // Demo Page
    demo: {
      title: 'Experimente o ZentraQR',
      subtitle: 'Explore as funcionalidades como cliente ou como gestor do restaurante',
      clientView: 'Visão do Cliente',
      clientDesc: 'Experimente como os seus clientes vão fazer pedidos',
      adminView: 'Painel Admin',
      adminDesc: 'Veja como vai gerir o seu restaurante',
      startTour: 'Iniciar Tour Guiado',
      skipTour: 'Saltar Tour',
      nextStep: 'Próximo',
      prevStep: 'Anterior',
      finishTour: 'Concluir',
      // Tour steps
      tourWelcome: 'Bem-vindo ao ZentraQR!',
      tourWelcomeDesc: 'Vamos mostrar-lhe como funciona o sistema. Este tour guiado dura cerca de 2 minutos.',
      tourMenu: 'Menu Digital',
      tourMenuDesc: 'Os clientes veem o menu completo com fotos, descrições e preços. Podem filtrar por categorias.',
      tourCart: 'Carrinho de Compras',
      tourCartDesc: 'Os clientes adicionam produtos ao carrinho e podem personalizar com extras.',
      tourOrder: 'Fazer Pedido',
      tourOrderDesc: 'Com um clique, o pedido é enviado diretamente para a cozinha.',
      tourDashboard: 'Dashboard Admin',
      tourDashboardDesc: 'Aqui você vê todos os pedidos em tempo real, estatísticas e receitas.',
      tourOrders: 'Gestão de Pedidos',
      tourOrdersDesc: 'Altere o estado dos pedidos: Recebido → Em Preparo → Pronto → Entregue.',
      tourComplete: 'Tour Completo!',
      tourCompleteDesc: 'Agora você conhece o básico do ZentraQR. Pronto para começar?',
      // Demo menu
      categories: 'Categorias',
      allItems: 'Todos',
      addToCart: 'Adicionar',
      cart: 'Carrinho',
      total: 'Total',
      placeOrder: 'Fazer Pedido',
      emptyCart: 'Carrinho vazio',
      orderPlaced: 'Pedido enviado!',
      table: 'Mesa',
      // Demo admin
      todayOrders: 'Pedidos Hoje',
      revenue: 'Receita',
      activeOrders: 'Pedidos Ativos',
      recentOrders: 'Pedidos Recentes',
      status: {
        received: 'Recebido',
        preparing: 'Em Preparo',
        ready: 'Pronto',
        delivered: 'Entregue',
      },
      items: 'itens',
    },
    // Common
    common: {
      ordersToday: 'Pedidos Hoje',
      revenue: 'Receita',
      lastHour: 'Última hora',
      newOrder: 'Novo Pedido',
      table: 'Mesa',
      live: 'Live',
      vsYesterday: 'vs ontem',
    },
      login: {
        title: 'Login de Cliente',
        description: 'Introduza as suas credenciais para gerir o seu restaurante.',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        // Adiciona esta linha abaixo:
        "Forgot Password": 'Esqueci-me da palavra-passe', 
        button: 'Entrar na conta',
        buttonLoading: 'A entrar...',
        footer: 'Ao entrar, concorda com os nossos Termos de Serviço e Política de Privacidade.',
        quote: '"A Zentra revolucionou a forma como gerimos os pedidos e a experiência dos nossos clientes à mesa."',
        toastSuccess: 'Login realizado com sucesso.',
        toastError: 'Credenciais inválidas.',
        toastConnError: 'Falha na conexão com o servidor.',
  },
    // Waitlist Section
    waitlist: {
      badge: 'Acesso antecipado',
      title: 'Estamos a abrir o acesso à ZentraQR por fases',
      description: 'Estamos a testar o MVP com um grupo limitado de espaços. Entre na whitelist para pedir acesso antecipado.',
      nameLabel: 'O seu nome',
      namePlaceholder: 'João Silva',
      businessLabel: 'Nome do restaurante / negócio',
      businessPlaceholder: 'Nome do seu restaurante',
      emailLabel: 'Email',
      emailPlaceholder: 'voce@restaurante.com',
      phoneLabel: 'Telefone (opcional)',
      phonePlaceholder: '+351 912 345 678',
      tablesLabel: 'Número de mesas (opcional)',
      tablesPlaceholder: 'Ex: 15',
      messageLabel: 'Conte-nos um pouco sobre o seu negócio (opcional)',
      messagePlaceholder: 'Tipo de cozinha, localização, o que espera da ZentraQR...',
      cta: 'Entrar na whitelist',
      ctaLoading: 'A submeter...',
      successTitle: 'Está na lista!',
      successMessage: 'Obrigado pelo interesse. Entraremos em contacto em breve.',
      errorDuplicate: 'Este email já está na whitelist',
      errorGeneric: 'Ocorreu um erro. Tente novamente.',
      benefit1: 'Configuração acompanhada',
      benefit2: 'Acesso antecipado a novas funcionalidades',
      benefit3: 'Onboarding mais próximo durante o MVP',
    }
  },
  en: {
    // Navbar
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      faq: 'FAQ',
      contact: 'Contact',
      demo: 'Demo',
      login: 'Login',
    },
    // Hero Section
    hero: {
      badge: 'New: Automatic payments',
      title1: 'Orders. Management. Payments.',
      title2: 'All in one place.',
      description: 'Transform your restaurant with digital QR Code menus. Customers order from their phones, you manage everything in real-time.',
      cta: 'Get Started',
      demo: 'View Demo',
      socialProof: '500+ restaurants',
      socialProofSub: 'already use ZentraQR',
    },
    // Problem Section
    problem: {
      title1: 'Because restaurant management',
      title2: "shouldn't be complicated",
      description: "We've lived the restaurant chaos — so we built a simpler way to manage orders and connect with customers.",
      card1Title: 'All in One Place',
      card1Desc: 'No more scattered apps. Chat, orders, and payments in one organized system.',
      card2Title: 'Frictionless Payments',
      card2Desc: "Clear pricing and instant payment — because getting paid shouldn't be a guessing game.",
      card3Title: 'Trusted System',
      card3Desc: 'Every order is logged and traceable. Focus on service, not on worries.',
    },
    // Marquee
    marquee: {
      title: 'For all types of establishments',
      restaurants: 'Restaurants',
      cafes: 'Cafés',
      bars: 'Bars',
      bistros: 'Bistros',
      foodCourts: 'Food Courts',
      pizzerias: 'Pizzerias',
      bakeries: 'Bakeries',
      rooftops: 'Rooftops',
      gastrobars: 'Gastrobars',
      canteens: 'Canteens',
    },
    // Features Section
    features: {
      title1: "We've done the hard part,",
      title2: 'now it\'s your turn to serve',
      description: 'Whether managing the restaurant or letting customers order, everything is designed to flow naturally.',
      tabRestaurant: 'For the Restaurant',
      tabClient: 'For the Customer',
      // Restaurant features
      dashboard: 'Real-Time Dashboard',
      dashboardDesc: 'Track orders, revenue, and statistics live. View everything in one panel.',
      orders: 'Order Management',
      ordersDesc: 'Receive and manage orders automatically. Instant notifications for the kitchen.',
      payments: 'Automatic Payment',
      paymentsDesc: 'Stripe integration for online payments. Customers pay directly from their phones.',
      menu: 'Menu Management',
      menuDesc: 'Add, edit, and organize categories and products easily. Photos and extras included.',
      // Client features
      scan: 'Scan & Order',
      scanDesc: 'Just scan the QR code at the table to access the full menu instantly.',
      interface: 'Intuitive Interface',
      interfaceDesc: 'Visual menu with photos, descriptions, and prices. Simple and fast navigation.',
      callWaiter: 'Call Waiter',
      callWaiterDesc: 'One click to call the waiter to your table. No unnecessary waiting.',
      trackOrder: 'Track Order',
      trackOrderDesc: 'See your order status in real-time. Know when it\'s ready.',
    },
    // How it works
    howItWorks: {
      title: 'Get started in',
      titleHighlight: '3 simple steps',
      step1: 'Configure the Menu',
      step1Desc: 'Add categories, products with photos and prices. Customize with your brand colors.',
      step2: 'Print QR Codes',
      step2Desc: 'Generate unique QR codes for each table. Print and place them on your tables.',
      step3: 'Receive Orders',
      step3Desc: 'Customers scan, order, and you manage everything on the real-time dashboard.',
    },
    // Pricing
    pricing: {
      title: 'Simple and',
      titleHighlight: 'Transparent Plans',
      description: 'Choose the ideal plan for your business size',
      monthly: 'Monthly',
      annual: 'Annual',
      discount: '-20%',
      mostPopular: 'MOST POPULAR',
      starter: 'Starter',
      starterDesc: 'For small restaurants',
      pro: 'Pro',
      proDesc: 'For growing restaurants',
      enterprise: 'Enterprise',
      enterpriseDesc: 'For chains and franchises',
      month: '/month',
      custom: 'Custom',
      cta: 'Start Free',
      ctaEnterprise: 'Talk to Sales',
      // Features
      tables10: 'Up to 10 tables',
      tables30: 'Up to 30 tables',
      tablesUnlimited: 'Unlimited tables',
      menuUnlimited: 'Unlimited menu',
      dashboardBasic: 'Basic dashboard',
      dashboardAdvanced: 'Advanced dashboard',
      emailSupport: 'Email support',
      prioritySupport: 'Priority support',
      onlinePayments: 'Online payments',
      realTimeNotifications: 'Real-time notifications',
      multiRestaurants: 'Multi-restaurants',
      customAPI: 'Custom API',
      integrations: 'Integrations',
      dedicatedManager: 'Dedicated manager',
      slaGuaranteed: 'Guaranteed SLA',
    },
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      description: 'Everything you need to know about ZentraQR',
      q1: 'How long does setup take?',
      a1: 'Less than 30 minutes. Just create an account, add your menu, and print the QR codes. Our system is intuitive and requires no technical knowledge.',
      q2: 'Do I need special hardware?',
      a2: 'No! ZentraQR works with any device with internet access. Your customers use their own phones and you manage everything through the browser.',
      q3: 'How do payments work?',
      a3: 'We integrate with Stripe for secure payments. Customers can pay online via phone or choose to pay at the counter. You decide which options to offer.',
      q4: 'Can I customize the menu?',
      a4: 'Absolutely! Add categories, products with photos, descriptions, extras, and set prices. You can also customize colors to match your brand.',
      q5: 'Is there a trial period?',
      a5: 'Yes! We offer 14 days free with no commitment and no credit card required. Try all features before deciding.',
    },
    // CTA Section
    cta: {
      title1: 'Ready to transform',
      title2: 'your restaurant?',
      description: 'Join 500+ restaurants that have already simplified order management. Start free today.',
      button: 'Start Free for 14 Days',
      noCard: 'No credit card required',
      quickSetup: '5 min setup',
      cancelAnytime: 'Cancel anytime',
    },
    // Footer
    footer: {
      description: 'Complete digital menu system via QR Code. Orders, management, and payments — all in one place.',
      product: 'Product',
      contact: 'Contact',
      sendMessage: 'Send message →',
      rights: '© 2026 ZentraQR. All rights reserved.',
      terms: 'Terms',
      privacy: 'Privacy',
      admin: 'Admin',
    },
    // Demo Page
    demo: {
      title: 'Try ZentraQR',
      subtitle: 'Explore features as a customer or restaurant manager',
      clientView: 'Customer View',
      clientDesc: 'Experience how your customers will place orders',
      adminView: 'Admin Panel',
      adminDesc: 'See how you will manage your restaurant',
      startTour: 'Start Guided Tour',
      skipTour: 'Skip Tour',
      nextStep: 'Next',
      prevStep: 'Previous',
      finishTour: 'Finish',
      // Tour steps
      tourWelcome: 'Welcome to ZentraQR!',
      tourWelcomeDesc: "Let's show you how the system works. This guided tour takes about 2 minutes.",
      tourMenu: 'Digital Menu',
      tourMenuDesc: 'Customers see the full menu with photos, descriptions, and prices. They can filter by category.',
      tourCart: 'Shopping Cart',
      tourCartDesc: 'Customers add products to cart and can customize with extras.',
      tourOrder: 'Place Order',
      tourOrderDesc: 'With one click, the order is sent directly to the kitchen.',
      tourDashboard: 'Admin Dashboard',
      tourDashboardDesc: 'Here you see all orders in real-time, statistics, and revenue.',
      tourOrders: 'Order Management',
      tourOrdersDesc: 'Change order status: Received → Preparing → Ready → Delivered.',
      tourComplete: 'Tour Complete!',
      tourCompleteDesc: 'Now you know the basics of ZentraQR. Ready to get started?',
      // Demo menu
      categories: 'Categories',
      allItems: 'All',
      addToCart: 'Add',
      cart: 'Cart',
      total: 'Total',
      placeOrder: 'Place Order',
      emptyCart: 'Empty cart',
      orderPlaced: 'Order sent!',
      table: 'Table',
      // Demo admin
      todayOrders: "Today's Orders",
      revenue: 'Revenue',
      activeOrders: 'Active Orders',
      recentOrders: 'Recent Orders',
      status: {
        received: 'Received',
        preparing: 'Preparing',
        ready: 'Ready',
        delivered: 'Delivered',
      },
      items: 'items',
    },
    // Common
    common: {
      ordersToday: "Today's Orders",
      revenue: 'Revenue',
      lastHour: 'Last hour',
      newOrder: 'New Order',
      table: 'Table',
      live: 'Live',
      vsYesterday: 'vs yesterday',
    },
    login: {
      title: 'Client Login',
      description: 'Enter your credentials to manage your restaurant.',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      button: 'Sign in',
      buttonLoading: 'Signing in...',
      footer: 'By signing in, you agree to our Terms of Service and Privacy Policy.',
      quote: '"Zentra has revolutionized how we manage orders and our customers\' experience at the table."',
      toastSuccess: 'Login successful.',
      toastError: 'Invalid credentials.',
      toastConnError: 'Server connection failed.',
    },
    // Waitlist Section
    waitlist: {
      badge: 'Early access',
      title: "We're opening access to ZentraQR in stages",
      description: "We're testing the MVP with a limited group of venues. Join the whitelist to request early access.",
      nameLabel: 'Your name',
      namePlaceholder: 'John Smith',
      businessLabel: 'Restaurant / Business name',
      businessPlaceholder: 'Restaurant name',
      emailLabel: 'Email',
      emailPlaceholder: 'you@restaurant.com',
      phoneLabel: 'Phone (optional)',
      phonePlaceholder: '+351 912 345 678',
      tablesLabel: 'Number of tables (optional)',
      tablesPlaceholder: 'E.g. 15',
      messageLabel: 'Tell us a bit about your business (optional)',
      messagePlaceholder: 'Type of cuisine, location, what you expect from ZentraQR...',
      cta: 'Join the whitelist',
      ctaLoading: 'Submitting...',
      successTitle: 'You are on the list!',
      successMessage: "Thanks for your interest. We'll be in touch soon.",
      errorDuplicate: 'This email is already on the whitelist',
      errorGeneric: 'An error occurred. Please try again.',
      benefit1: 'Guided setup',
      benefit2: 'Early access to new features',
      benefit3: 'Closer onboarding during MVP',
    }
  },
};

export default translations;
